module.exports = __webpack_public_path__ + "b1755041374772e09546de41fd4e3682.pdf";